import { useAppDispatch } from '@common/hooks/store';
import { authApi } from '@features/auth/api/authApi';
import { bonusExpressApi } from '@features/bonus-express/api/bonusExpressApi';
import { freespinApi } from '@features/freespin/api/freespinApi';
import { useCallback } from 'react';

const FRESH = { subscribe: false, forceRefetch: true } as const;

export default function usePromoRewardRefresh() {
  const dispatch = useAppDispatch();

  return useCallback(() => {
    dispatch(authApi.endpoints.checkToken.initiate(undefined, FRESH));
    dispatch(freespinApi.endpoints.getUserBonusCards.initiate(undefined, FRESH));
    dispatch(bonusExpressApi.endpoints.getExpressBonuses.initiate(undefined, FRESH));
  }, [ dispatch ]);
}
